import { render } from "./AdminSitesView.vue?vue&type=template&id=72bb63c4&scoped=true"
import script from "./AdminSitesView.vue?vue&type=script&lang=js"
export * from "./AdminSitesView.vue?vue&type=script&lang=js"

import "./AdminSitesView.vue?vue&type=style&index=0&id=72bb63c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bb63c4"]])

export default __exports__